import { inRange } from 'lodash/fp';
import { useMemo } from 'react';
import { Field } from 'redux-form';
import styled from 'styled-components';

import InputField from 'dashboard/components/FormControls/InputField';
import HelpIcon from 'dashboard/components-lib/HelpIcon';
import { withMessage } from 'lib/utils/formValidation';

const StyledInputField = styled(InputField).attrs(() => ({ size: 'md' }))`
  width: 170px;
`;

export const INTERVAL_RANGE_ERROR = 'Must be between 1 and 25';
const MAX_INQUIRY_SESSIONS = 25;

const createValidations = ({
  initialMaxSessionLimit,
}: {
  initialMaxSessionLimit: number | null;
}) => [
  withMessage(INTERVAL_RANGE_ERROR, (value: number | null) => {
    if (value == null) {
      return value === initialMaxSessionLimit;
    }
    return value === initialMaxSessionLimit || inRange(1, MAX_INQUIRY_SESSIONS + 1, value);
  }),
];

interface FormSectionSessionsConfigProps {
  initialMaxSessionLimit: number | null;
}

const FormSectionSessionsConfig = ({ initialMaxSessionLimit }: FormSectionSessionsConfigProps) => {
  const validations = useMemo(() => {
    return createValidations({ initialMaxSessionLimit });
  }, [initialMaxSessionLimit]);

  return (
    <Field
      id='max-session-limit'
      key='max-session-limit'
      name='max-session-limit'
      aria-labelledby='Inquiry Sessions Limit'
      label={
        <span>
          Inquiry Sessions Limit
          <HelpIcon>
            Users will see an error when attempting to open a specific Inquiry beyond the limit
            configured here.
          </HelpIcon>
        </span>
      }
      // Despite our backend allowing max 100, we limit to 25 on the frontend
      max={MAX_INQUIRY_SESSIONS}
      min={1}
      type='number'
      width='300px'
      validate={validations}
      parse={(value: string) => (value === '' ? null : Number(value))}
      component={StyledInputField}
    />
  );
};

export default FormSectionSessionsConfig;
